import React from 'react';
import PropTypes from 'prop-types';
import { Translation } from 'react-i18next';

import './LinksEmptyState.css';


const LinksEmptyState = ({ text }) => (
  <div className="links-empty-state__component">
    <div className="arrow" />
    <div className="text">
      {text}
    </div>
  </div>
);

LinksEmptyState.propTypes = {
  text: PropTypes.node,
};
LinksEmptyState.defaultProps = {
  text: <>
    <Translation>
      {(t) => (
        <div>
          <div>{t("Paste")}</div>
          <div><strong>{t("your first")}</strong></div>
          <div><strong>{t("link")}</strong> {t("here")}</div>
        </div>
      )}
    </Translation>
  </>
};

export default LinksEmptyState;
